import React, { useEffect, useState } from "react";
import api from "../../api";
import { useParams, useNavigate } from "react-router-dom";

export default function MegaScholarshipLeaderboard() {
  const { id } = useParams();
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadLeaderboard = async () => {
      try {
        const res = await api.get(
          `/student/mega-scholarship/${id}/leaderboard`
        );
        setRows(res.data?.leaderboard || []);
      } catch {
        alert("Leaderboard not available");
        nav(`/student/result/mega/${id}`);
      } finally {
        setLoading(false);
      }
    };

    if (id) loadLeaderboard();
  }, [id, nav]);

  if (loading) return <p style={{ padding: 30 }}>Loading leaderboard...</p>;

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          <Header />

          <h2>🏆 Mega Scholarship Leaderboard</h2>

          <table width="100%" border="1" style={{ marginTop: 20 }}>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Name</th>
                <th>Score</th>
                <th>Time</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td>#{r.rank}</td>
                  <td>{r.student_name}</td>
                  <td>{r.score}</td>
                  <td>{r.time_taken_seconds}s</td>
                  <td>{r.amount_released ? "✅ Released" : "⏳ Processing"}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <button onClick={() => nav(`/student/result/mega/${id}`)}>
            ⬅ Back to Result
          </button>
        </div>
      </div>
    </div>
  );
}

/* ---------- HEADER ---------- */
function Header() {
  return (
    <div style={{ textAlign: "center", marginBottom: 20 }}>
      <img src="/logo.png" alt="EduAt10" style={{ width: 120 }} />
    </div>
  );
}

/* ---------- STYLES ---------- */
const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};
const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};
const cardStyle = {
  maxWidth: 1100,
  margin: "auto",
  background: "rgba(255,255,255,0.95)",
  borderRadius: 16,
  padding: 30,
};
